import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { SearchContext } from '../../../../../contexts/SearchContext'
import ReactMultiSelect from '../../../../FormComponents/ReactMultiSelect'

export default observer(function AgeGroupFilter() {
  const { search } = useContext(SearchContext)

  const ageGroupOptions = [
    { label: "13-17", value: "13-17" },
    { label: "18-24", value: "18-24" },
    { label: "25-34", value: "25-34" },
    { label: "35-44", value: "35-44" },
    { label: "45-64", value: "45-64" },
    { label: "65-", value: "65-" },
  ]

  const setAgeGroupFilter = (ageGroups) => {
    search.age_group = ageGroups.map(ageGroup => ageGroup.value)
    search.selectedAgeGroups = ageGroups
  }

  return (
    <div className="w-full">
      <ReactMultiSelect
        placeholder="Any age"
        name="filter"
        onChange={setAgeGroupFilter}
        options={ageGroupOptions}
        value={search.selectedAgeGroups}
        disableSearch
        hasSelectAll={false}
      />
    </div>
  )
})